<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>医疗资源</a></li>
            </ul>
            <div class="page-main">
                <h3>医疗资源</h3>
                <ul class="medical-ul">
                    <li class="medical-item" v-for="medical in medicalList" :key="medical.Id" @click="goDetail(medical)">
                        <h3 class="ellipsis_one">{{ medical.Title }}</h3>
                        <div class="medical-item-btm">
                            <p class="subTitle ellipsis_three">{{ medical.SubTitle }}</p>
                            <el-divider>特色诊室</el-divider>
                            <p class="ellipsis_four" v-html="medical.Content"></p>
                        </div>
                    </li>
                    <!-- <li class="medical-item">
                        <h3>中国医学科学院北京协和医院</h3>
                        <div class="medical-item-btm">
                            <p class="subTitle ellipsis_three">北京协和医院是全国顶尖医院，综合总实力最强设有27个疑难杂症会诊中心。</p>
                            <el-divider>特色诊室</el-divider>
                            <p class="ellipsis_four">风湿科(全国第一)、普通外科(全国第一)、妇产科(全国第一)、内分泌科(全国第二)、消化内科(全国第二)、重症医学(全国第二)、神经内科(全国第二)、整形外科(全国第四)、五官科科(全国第五)</p>
                        </div>
                    </li>
                    <li class="medical-item">
                        <h3>中国医学科学院北京协和医院</h3>
                        <div class="medical-item-btm">
                            <p class="subTitle">北京协和医院是全国顶尖医院，综合总实力最强设有27个疑难杂症会诊中心。</p>
                            <el-divider>特色诊室</el-divider>
                            <p class="ellipsis_four">风湿科(全国第一)、普通外科(全国第一)、妇产科(全国第一)、内分泌科(全国第二)、消化内科(全国第二)、重症医学(全国第二)、神经内科(全国第二)、整形外科(全国第四)、五官科科(全国第五)</p>
                        </div>
                    </li> -->
                </ul>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getMedical
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            total: 0,
            currentPage: 1,
            pageSize: 12,
            medicalList: [],
        }
    },
    created() {
        this.getMedical();
    },
    methods: {
        getMedical() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
            };
            getMedical(params).then(res => {
                if (res.Code == 1) {
                    this.medicalList = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("医疗科普请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getMedical();
        },
        goDetail(medical) {
            window.open(medical.Remark, '_blank');
        }
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px 20px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.medical-ul{
    padding: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.medical-ul .medical-item:nth-child(3n) {
    margin-right:0;
}
.medical-item {
    margin-right: 12px;
    cursor: pointer;
    margin-bottom: 12px;
}

.medical-item h3{
    width: 384px;
    height: 60px;
    background: #116EBA;
    color: #fff;
    font-size: 18px;
    line-height: 60px;
}
.medical-item-btm{
    padding: 16px 20px;
    width: 384px;
    height: 270px;
    box-sizing: border-box;
    border: 1px solid #E5E5E5;
    background:#fff;
}
.medical-item-btm p {
    line-height: 26px;
    color: #6A6A6A;

}
.subTitle {
    margin-bottom: 10px;
}
.el-divider {
    background: #116EBA;
}
.el-divider__text{
    color: #116EBA;
    font-size:18px;
}
</style>